export default __webpack_public_path__ + "static/media/footer1.360ac1cf.jpeg";